import type { ReactNode } from "react";
import logo from "./CT_Logo.png";

export function AuthLayout({ children }: { children: ReactNode }): JSX.Element {
  return (
    <main className="flex min-h-svh flex-col items-center justify-center bg-muted px-4 py-10 sm:px-6">
      <div className="flex w-full max-w-md flex-col gap-8">
        <img src={logo} alt="Claymore Thistle" className="mx-auto h-16 w-auto sm:h-20" />
        {children}
      </div>
    </main>
  );
}
